import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { I18nService } from 'src/app/service/i18n.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FbPaidPixelService } from 'src/app/service/fbpaid-pixel.service'
import { GAdsPaidPixelService } from 'src/app/service/gads-paid-pixels.service';
import { DvtagPaidPixelService } from 'src/app/service/dvgtag-paid-pixels.service';
import { environment } from 'src/environments/environment';
import { PreQualData } from 'src/app/model/pre-qual-data.model';


@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./landing.component.less']

})
export class LandingComponent implements OnInit {
  privacyandsecurityLink: string = "";
  currentRoutePath: string = '';
  currentLang: string;
  innerWidth: any;
  praprovalformlink: string;
  pilotFlow: any;
  productFlow: string;
  privacyandsecurityLinkSummary: string;
  flowType: any;
  preQualObj: PreQualData;
  referralFlow: any;

  prequalType = 'P';
  switchType = 'S'; constructor(private router: Router,
    private _activatedRoute: ActivatedRoute,
    private util: UtilService,
    private utilService: UtilService,
    private translate: TranslateService,
    private i18nService: I18nService,
    private fpService: FbPaidPixelService,
    private dvService: DvtagPaidPixelService,
    private gadsService: GAdsPaidPixelService) {
  }

  ngOnInit(): void {
    // this.mHttp.decodeText("ks37iZ/KgirV+cONjhqAEyn/bHSE2TnTLL7c7L/HBK63XMFSQ+QaiRICc1pwNWM5OZ4cAoio0R0L+VU+Ik/hhTgemM45EzAHjM0ewUO+yPDV+nH0dt0swillkbYWmdaIuam5r6j83zLFpGiSaSUS3so89d9LVgI/Vu3EXvsvMcAeq7jeB4MgrwxnuMs5OJs105rjmeDoX2aQ4waMCkGwS/BasJNZbWed0YE4iKCy8uIOvXrDgQ7mEt1XMUh76QcvfVgBppveKlxKi13XitcxdMEQcl/RVe/0Vfxk/CVtFEtOv2cOBo/vTK+oj++mGjbnl9ZzDn1EZTYVHxs93OY7iRS64hquhZK5vquVAZrtRyx6sPyJdsl4xIWyypUGZmu/XnsU6ud+nAEQBpTRZqUrRfM0kWPnRRkACW3UJrIL4n68lpOZRGEDG31NXTjmohWEwOJIFOI6yYJMF5Fu8zfyufUqFwijNyW+RybrmfBpt1ER0Nuc8nFgwYQQ7RRn0dnzCFnxCnQlKa+hqcylc4tK0Y5YD9BjnKoCNK1sRZ9YtalZZkdF+PmLbvEYFtg1gXY6wtbm4jAfrSrfsBTImS7f6N51VKfOKWAhSwD6/kYVdH3tm3CR0vdZQvEdYGsO2rRKsHOgS3YAO4vgwK9FV12MtMJT7hcVSIZ/cvJiBTHTUpuK/Q3jol4Po/Vje2l4EGtbqOUd1qW0QQzk60Zt9rCmTJY0f1EVCFaapkpxg93enaf49xe4deNNoZE4sjJGJ/9Ollt4HYbvnkDnVKYCTmtMURwQcQmDUtRg1lc0Q5CT7n4cSCfHJXDbt1UVDajboPdIlPT2i1L+NgUOkvcx3pxXfTtwMDFqsnjK7+Ygiiv9+ypFrrEc/5ugqmteGo3GSdAMqLkuG7rkeLrGxDOND5/917+sXTvQA4bnNdE/QFC8QgCSRPcU3pKBtIwPwJtPm93o/P2oNqCtrmXn1Ar55t7wS9NlEN6O2/26FtJOqFH3fOvzcrnVSQIgvwqCglFYYsEMzNSaBifpw5ocnQqHlsXuA9ktCRrW0gMaNoITRnfiLH7m08koRgDE0d6PAqH+NaoybrNUSATaZ3r7EXqu4ZoTYx75VMWDtzyEy52O2BrxOmGHee5bCwgQFfBtvJevj+GQSqxMANy3NLyZkim7h9lhx2z8/ZLtXWvSprx75xKp9ysUztsdjurrQMOhP+GZReoAcfaZkPX78ilJimh0664w9zG43rf1hRnCo5ol+J9k0+OHXgYVuMGB3aGzwf6JYmHXVhn9/LbKAusJKOBVU+tFeiJgLR6rzNhcSvlkcuVDnUJHoMpkbKA3Dk9hR73lKv/fLKjObJ6JvqMOncYZxU1moXNlizAQC58qg7ov0OxCN6xgpKZUNcK6a9VdtPbGXul7zw4O0DYwyvZK6xG4yGW/dAuKQWT+l+cUCqDfYqQdXLcKUAEtPddc1OBdv3ovxKohBXZHL00KVw8T5zRynZp1nIqM/z1AEZua01m/wFrOwFor+QDnKX9WgG9sDOIi9PzR")
    //console.log("pilotflow", sessionStorage.getItem("pilotflow") )
    this.initData();
    this.setTestData();

  }
  initData() {
    this.preQualObj = new PreQualData();
    this.util.isSidebarVisible.next(true);
    this.util.isSummaryPage.next(false);
    this.util.progressPercent.next(0);

    this._activatedRoute.queryParams.subscribe(params => {
      this.flowType = this.util.getFlowType(params);
      this.referralFlow = this.util.getReferral(params);
    });
    this.translate.onLangChange.subscribe((e: LangChangeEvent) => {
      let lang = e.lang || "en";
      sessionStorage.setItem("currLang", e.lang);
      this.currentLang = e.lang;
    });
    this.flowType?.type == this.prequalType ? this.util.sidebarTitle.next('slideTitles.home') : this.util.sidebarTitle.next('slideTitles.digiHome');

    this.utilService.windowWidth.subscribe(val => {
      this.innerWidth = val;
    });
    this.currentLang = this.i18nService.getCurrentLang();
    if (!this.currentLang) {
      this.currentLang = sessionStorage.getItem("currLang");
    }
    if (this.currentLang != sessionStorage.getItem("lang_pref")) {
      this.currentLang = sessionStorage.getItem("lang_pref");
    }
    sessionStorage.removeItem("pre_qual_data")
    sessionStorage.removeItem("transactionid")
    this.translate.get('footer.privacyandsecurityLink').subscribe((res: string) => {
      this.privacyandsecurityLink = res || "";
    });
    this.translate.get('footer.privacyandsecurityLinkSummary').subscribe((res: string) => {
      this.privacyandsecurityLinkSummary = res || "";
    });
    this.translate.get('Notyetaclient.praprovalformlink').subscribe((res: string) => {
      this.praprovalformlink = res || "";
    });
    var env = environment.env;
    // to load paid pixels only for production
    if (env == "prod") {
      //load the fb pixel
      this.fpService.load('start')
      //load the dv360 pixel
      if (!document.getElementById("dvgtag")) {
        this.dvService.load('start')
      }
      // load the google ads pixel
      if (!document.getElementById("gads")) {
        this.gadsService.load('start')
      }
    }
  }
  setTestData() {
    if (this.referralFlow) {
      this.preQualObj.referralLink = window.location.href;
    }

    this.utilService.setSessionStorage(this.preQualObj);
  }

  onContinue() {
    if (!this.util.getSessionStorage()) {
      this.setTestData();
      this.initData();
    }
    this.router.navigate(['../co-applicant-selection'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
  }
}
